module.exports = __webpack_public_path__ + "static/headshot-michael-lynn-2x.c1336d05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-michael-lynn-2x.jpg
// module id = 525
// module chunks = 152909308826437